"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSearchPages = getSearchPages;
exports.getSearchPagesActions = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _common = require("../utils/common");

var _ContentDelivery = _interopRequireDefault(require("../services/ContentDelivery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var getSearchPagesActions = (0, _common.makeFetchActions)('GET_SEARCH_PAGES');
/**
 * Load publication's pages which fulfill the searchQuery requirement
 *
 * @param {String} params search params of specific publication
 * @param {Function} callback
 * @returns {Promise}
 */

exports.getSearchPagesActions = getSearchPagesActions;

function getSearchPages(_ref, callback) {
  var publicationId = _ref.publicationId,
      searchQuery = _ref.searchQuery,
      requestCallback = _ref.requestCallback;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(dispatch) {
      var response;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              if (requestCallback) {
                requestCallback();
              }

              dispatch(getSearchPagesActions.request({
                publicationId: publicationId
              }));
              _context.next = 5;
              return _ContentDelivery["default"].getSearchPages({
                publicationId: publicationId,
                searchQuery: searchQuery
              });

            case 5:
              response = _context.sent;
              dispatch(getSearchPagesActions.success({
                publicationId: publicationId,
                data: response.data
              }));
              if (callback) callback(response.data);
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              dispatch(getSearchPagesActions.error({
                publicationId: publicationId,
                error: _context.t0
              }));

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 10]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
}